/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DueState = {
    NotDue: 'NotDue',
    Due: 'Due',
    Overdue: 'Overdue'
} as const;
export type DueState = typeof DueState[keyof typeof DueState];


export function DueStateFromJSON(json: any): DueState {
    return DueStateFromJSONTyped(json, false);
}

export function DueStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DueState {
    return json as DueState;
}

export function DueStateToJSON(value?: DueState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the DueState interface.
 */
 export function instanceOfDueState(value: any): value is DueState {
    return Object.values(DueState).includes(value)
}

